import React from 'react'

export default function CheckboxIcon(){
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M17.5556 3.8H6.44444C4.98396 3.8 3.8 4.98396 3.8 6.44444V17.5556C3.8 19.016 4.98396 20.2 6.44444 20.2H17.5556C19.016 20.2 20.2 19.016 20.2 17.5556V6.44444C20.2 4.98396 19.016 3.8 17.5556 3.8ZM6.44444 2C3.98985 2 2 3.98985 2 6.44444V17.5556C2 20.0102 3.98985 22 6.44444 22H17.5556C20.0102 22 22 20.0102 22 17.5556V6.44444C22 3.98985 20.0102 2 17.5556 2H6.44444Z" fill="#B1AEC7"/>
        </svg>
    )
}
